<ion-content>
  <div class="splash">
    <ion-spinner name="lines"></ion-spinner>
  </div>
</ion-content>
<!--
<ng-template *ngIf="lottery$ | async"> </ng-template>

<ng-template *ngIf="jackpot$ | async"> </ng-template>

<ng-template *ngIf="euroMillion$ | async"> </ng-template>
<ng-template *ngIf="Eurojackpot$ | async"> </ng-template>
<ng-template *ngIf="Lotto$ | async"> </ng-template>
<ng-template *ngIf="PowerBall$ | async"> </ng-template>
<ng-template *ngIf="SuperenaLotto$ | async"> </ng-template>
<ng-template *ngIf="ThunderBall$ | async"> </ng-template>
<ng-template *ngIf="MegaMillions$ | async"> </ng-template>
<ng-template *ngIf="Irish$ | async"> </ng-template> -->
@if (languageList$ | async) {
}
@if (homePageData$ | async) {
}
@if (lotteryLInes$ | async) {
}
@if (charity$ | async) {
}
